import styled from "styled-components";

export const Divider = styled.hr`
	background-color: ${(props) => (props.color ? props.color : "#E9ECF1")};
	height: 1px;
	border: none;
	margin-top: ${(props) => (props.top ? props.top : "0px")};
	margin-bottom: ${(props) => (props.bottom ? props.bottom : "0px")};
`;
